/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { RECEIVE_EMAIL_DATA } from 'state/actions/emailCollectionState/selected_embed_email_data';
import { CLEAR_SELECTED_EMAIL_STATE } from 'state/actions/emailCollectionState/selected_embed_email_status';


/* ========== ~~~~~~~~~~ CONTENT EMAIL STATUS : REDUCER ~~~~~~~~~~ ========== */

const defaultState = {
    isDataReceived: false,
    embedEmails: [],
    currentPage: 1,
    totalRows: null,
    totalPages: null
};



// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components
const selectedEmbedEmailData = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case RECEIVE_EMAIL_DATA:
            newState.isDataReceived = true;
            newState.embedEmails = action.emailData.userData;
            newState.currentPage = action.emailData.currentPage;
            newState.totalRows = action.emailData.totalRows;
            newState.totalPages = action.emailData.totalPages;
            return newState;
        case CLEAR_SELECTED_EMAIL_STATE:
            return defaultState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default selectedEmbedEmailData;